import { URI } from '@/config/config';

export default async ({ rootState }) => {
  const url = new URL(`${URI}control-panel/consumer`);
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
    },
  };

  const userLoginInfoResult = await fetch(url, opts);
  const jsonResult = await userLoginInfoResult.json();
  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors);
  }

  return jsonResult.list;
};
